import type { Localizer } from "@/main/react/Types";
import type { LocalizationKey } from "@/main/util/LocalizationUtil";

const REPORT_REASON_LABEL_KEYS: Record<string, LocalizationKey> = {
    SPAM: "report.modal.reason.spam",
    HARASSMENT: "report.modal.reason.harassment",
    HATE_SPEECH: "report.modal.reason.hate_speech",
    ABUSE: "report.modal.reason.abuse",
    SEXUAL_CONTENT: "report.modal.reason.sexual_content",
    VIOLENCE_OR_THREATS: "report.modal.reason.violence_or_threats",
    ILLEGAL_CONTENT: "report.modal.reason.illegal_content",
    FRAUD_OR_IMPERSONATION: "report.modal.reason.fraud_or_impersonation",
    PRIVACY_VIOLATION: "report.modal.reason.privacy_violation",
    SELF_HARM: "report.modal.reason.self_harm",
    RULE_VIOLATION: "report.modal.reason.rule_violation",
    COPYRIGHT: "report.modal.reason.copyright",
    AI_SLOP: "report.modal.reason.ai_slop",
    OTHER: "report.modal.reason.other",
};

export function getDeletedContentReasonLabel(localizer: Localizer, reasonType?: string | null) {
    if (!reasonType) {
        return null;
    }

    const labelKey = REPORT_REASON_LABEL_KEYS[reasonType];
    return labelKey ? localizer(labelKey) : null;
}
